import { Component, OnInit } from '@angular/core';
import { ModalService, TokenService } from '@services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-contact-form',
  templateUrl: './modal-contact-form.component.html',
  styleUrls: ['./modal-contact-form.component.scss']
})
export class ModalContactFormComponent implements OnInit {
  public environment = environment;
  public modalContactForm: boolean = false;

  constructor(private modalService: ModalService) { }

  ngOnInit(): void {
    this.modalService.returnModalContactForm()
    .subscribe((modalContactForm: boolean) => {
      this.modalContactForm = modalContactForm;
    });
  }

  openModal(): void {
    this.modalService.openModalContactForm();
  }

  closeModal(): void {
    this.modalService.closeModalContactForm();
  }

  public get isLogged() {
    return TokenService.isLogged();
  }

}
